import { createVanIconComponent } from "./van"

const ArrowLeft = createVanIconComponent("arrow-left")
export default ArrowLeft
